import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {currentUserStore} from '../../../../../api/user';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, program} = contexts;

  const data: EventData = {};

  if (!program?.coach_ids?.includes(currentUserStore.user?._id || '')) {
    data.buttons = [
      {
        id: 'program_shared_message_button',
        label: i18n.t('notifications:program_shared.message_button'),
      },
    ];
  }

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:program_shared.title.coach')
       * t('notifications:program_shared.title.cocoach')
       * t('notifications:program_shared.title.removed-cocoach')
       */
      i18n.t(
        `notifications:program_shared.title.${
          program?.user_id === currentUserStore.user?._id
            ? 'coach'
            : program?.coach_ids?.includes(currentUserStore.user?._id || '')
              ? 'cocoach'
              : 'removed-cocoach'
        }`,
        {
          actorName: actor?.name,
          programTitle: program?.title,
        },
      ),
  };
};
